import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectInvoices = createSelector(
	(state: IStore) => state.invoices,
	(invoices) => invoices
)
